import { createFileRoute } from "@tanstack/react-router";
import { InformasjonOmNorgesprisPage } from "@/features/bestillinger/pages/InformasjonOmNorgesprisPage";

export const Route = createFileRoute("/_app/bestilling/ny/informasjon/")({
  component: InformasjonOmNorgesprisPage,
});
